import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService } from '../../../tms-shared';
import { TmsWebBaseChartService } from '../base';
import { ChartWeeksSalesInvoices } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class ChartWeeksSalesInvoiceService extends TmsWebBaseChartService<ChartWeeksSalesInvoices> {
  public refreshDetails = new Subject<void>();

  constructor(protected httpService: HttpService) {
    super('ChartWeeksSalesInvoices', httpService);
  }
}
